import { render, staticRenderFns } from "./IdeaModal.vue?vue&type=template&id=71634740&"
import script from "./IdeaModal.vue?vue&type=script&lang=js&"
export * from "./IdeaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports